import { ConsentModel, IConsentModel, IModel, IPhotoModel, Model, PhotoModel } from ".";

export interface IVisitConsentModel extends IModel {
    visitConsentId: number;
    visitId: number;
    consentId: number;
    clientSignaturePhotoId: number | undefined;
    consent: IConsentModel;
    clientSignaturePhoto: IPhotoModel;
}

export class VisitConsentModel extends Model implements Record<keyof IVisitConsentModel, any> {
    visitConsentId: number;
    visitId: number;
    consentId: number;
    clientSignaturePhotoId: number | undefined;
    consent: ConsentModel;
    clientSignaturePhoto: PhotoModel | undefined;

    constructor(params: IVisitConsentModel) {
        super(params);
        this.visitConsentId = params.visitConsentId;
        this.visitId = params.visitId;
        this.consentId = params.consentId;
        this.clientSignaturePhotoId = params.clientSignaturePhotoId;
        this.consent = new ConsentModel(params.consent);
        this.clientSignaturePhoto = params.clientSignaturePhoto ? new PhotoModel(params.clientSignaturePhoto) : undefined;
    }

}
